import { eventBus } from 'EventBus/';

export const busName = 'variantSelector';

export const handleShadeSelection = (shadeDescription) => {
  if (!shadeDescription) return;
  document.getElementById('current-shade').innerText = shadeDescription;
};

export const publishVariantSelectionEvent = (
  productEAN,
  productItemId,
  varintItemId
) => {
  if (!productEAN) return;
  eventBus.$emit(`${busName}::selected`, productEAN);
  window.eventBus.$emit('rfp-mctb-has-varient-component', {
    productItemId: productItemId.toUpperCase(),
    varintItemId: varintItemId.toUpperCase(),
  });
  // modifying Refapp analytics events product-id to use productEAN that is stored within variant
  window.eventBus.$emit('rfp-product-variant-data-update', {
    ean: productEAN,
  });
};

export const variantSelector = {
  name: 'lp-variant-selector',
  inserted: (el, binding) => {
    if (el.tagName === 'INPUT') {
      el.addEventListener('change', () => {
        handleShadeSelection(binding.value?.shade);
        publishVariantSelectionEvent(
          binding.value?.ean,
          binding.value?.productItemId,
          binding.value?.varintItemId
        );
      });
    }
  },
};
